// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3IUWq","header":"PatientQuestionnaire_header__b9wYA","info":"PatientQuestionnaire_info__3Vihz"};